export default {"src":"/_next/static/media/cancellation-policy.d03bb98f.svg","height":659,"width":586,"blurWidth":0,"blurHeight":0};